/* eslint-disable */
import React from 'react'
import { connect } from 'react-redux'
import {
  addFilter,
  fetchCategorizedRegItems,
  fetchCategories,
  fetchReservedRegItems,
  setFilters,
  setIsOrganizing,
} from '../actions'
import { REG_ITEM_RESERVATION_STATUS_AVAILABLE } from '../actions/reg-items-actions'
import {
  getCategorizedRegItems,
  getCategorizedRegItemsCount,
  getDistinctStores,
  getIsAllCategoriesCollapsed,
  isPageReady,
  getGroupGiftRegItemsCount,
  getIsContributorView,
  getIsFetchingCategorizedRegItems,
  getIsPartialSetOfRegItems,
  getIsOrganizing,
  getIsRegistryDiscountView,
  getPopulatedCategories,
  getRegItemsCount,
  getReservedRegItems,
  getInitialRegItemsCount,
  getFavoriteRegItemsCount,
  getReservationsByCurrentVisitor,
  getFilters,
  getRegistryCategories,
  getReservedRegItemsByCurrentVisitor,
  getIsMobile,
  getIsShippingAddressButtonVisible,
  getRegistryGuestViewOptimizationFeatureFlag,
} from '../reducers'
import {
  openContactInfoModal,
  openMobileFiltersModal,
  openGiftTrackerModal,
} from '../modals/actions'

export const registryPageDataFetcher = (WrappedComponent) => {
  class RegistryPageDataFetcher extends React.Component {
    componentDidMount() {
      const {
        isFetchingCategorizedRegItems,
        fetchCategorizedRegItems,
        isContributorView,
        registryGuestViewOptimizationFeatureFlag,
      } = this.props
      if (!isFetchingCategorizedRegItems) {
        if (!isContributorView && registryGuestViewOptimizationFeatureFlag) {
          // Fetching for available items to match the filter set in GuestFilterBar useEffect
          fetchCategorizedRegItems({ fetchAvailableOnly: true, limit: 3 }).then(
            () => {
              fetchCategorizedRegItems({ shouldFetchCategories: false })
            }
          )
        } else {
          fetchCategorizedRegItems()
        }
      }
    }

    render() {
      return <WrappedComponent {...this.props} />
    }
  }

  const mapStateToProps = (state, ownProps) => {
    const isRegistryDiscountView = getIsRegistryDiscountView(state)

    return {
      categories: getRegistryCategories(state),
      categorizedRegItems: getCategorizedRegItems(
        state,
        isRegistryDiscountView
      ),
      filters: getFilters(state),
      filteredRegItemsCount: getCategorizedRegItemsCount(state),
      isAllCategoriesCollapsed: getIsAllCategoriesCollapsed(state),
      isContributorView: getIsContributorView(state),
      isFetchingCategorizedRegItems: getIsFetchingCategorizedRegItems(state),
      isPartialSetOfRegItems: getIsPartialSetOfRegItems(state),
      isOrganizing: getIsOrganizing(state),
      isPageReady: isPageReady(state),
      isRegistryDiscountView,
      populatedCategories: getPopulatedCategories(
        state,
        isRegistryDiscountView
      ),
      regItemsCount: getRegItemsCount(state) || getInitialRegItemsCount(state),
      reservedRegItems: getReservedRegItems(state),
      favoriteRegItemsCount: getFavoriteRegItemsCount(state),
      groupGiftsRegItemsCount: getGroupGiftRegItemsCount(state),
      reservationsByCurrentVisitor: getReservationsByCurrentVisitor(state),
      reservedRegItemsByCurrentVisitor:
        getReservedRegItemsByCurrentVisitor(state),
      stores: getDistinctStores(state),
      isMobile: getIsMobile(state),
      isShippingAddressButtonVisible: getIsShippingAddressButtonVisible(state),
      registry: state.registry,
      registryGuestViewOptimizationFeatureFlag:
        getRegistryGuestViewOptimizationFeatureFlag(state),
    }
  }

  return connect(mapStateToProps, {
    fetchCategorizedRegItems,
    fetchCategories,
    fetchReservedRegItems,
    openMobileFiltersModal,
    addFilter,
    setFilters,
    setIsOrganizing,
    openContactInfoModal,
    openGiftTrackerModal,
  })(RegistryPageDataFetcher)
}
